import { gql } from '@apollo/client';

export const GET_SEGMENT_CATEGORIES = gql`
  query getSegmentCategories {
    segmentCategories {
      id
      name
    }
  }
`;

export const CREATE_CLIENT_SEGMENT_CATEGORY = gql`
  mutation createClientSegmentCategory($clientSegmentCategory: CreateClientSegmentCategory!) {
    createClientSegmentCategory(clientSegmentCategory: $clientSegmentCategory) {
      id
      name
    }
  }
`;

export const GET_CLIENT_SEGMENT_CATEGORIES = gql`
  query getClientSegmentCategories($clientId: ID!) {
    client(id: $clientId) {
      id
      segmentCategories {
        id
        name
        segments {
          id
          clientCategoryId
          name
        }
      }
    }
  }
`;

export const CREATE_CLIENT_SEGMENT = gql`
  mutation createClientSegment($segmentInput: CreateClientSegment!) {
    createClientSegment(clientSegment: $segmentInput) {
      id
      clientCategoryId
      name
    }
  }
`;

export const UPDATE_CLIENT_SEGMENT = gql`
  mutation updateClientSegment($clientSegmentId: ID!, $segmentInput: UpdateClientSegment!) {
    updateClientSegment(clientSegmentId: $clientSegmentId, clientSegment: $segmentInput) {
      id
      clientCategoryId
      name
    }
  }
`;

export const DELETE_CLIENT_SEGMENT = gql`
  mutation deleteClientSegment($clientId: ID!, $segmentId: ID!) {
    deleteClientSegment(clientId: $clientId, segmentId: $segmentId)
  }
`;

export const GET_DATA_ENTRY_SEGMENTS = gql`
  query getDataEntrySegments($clientId: ID!, $entryId: ID!) {
    client(id: $clientId) {
      dataEntrySegments(entryId: $entryId) {
        dataEntryId
        categories {
          clientCategoryId
          segments {
            id
            clientSegmentId
            amount
          }
        }
      }
    }
  }
`;

export const CREATE_DATA_ENTRY_SEGMENT = gql`
  mutation createDataEntrySegment($segment: CreateDataEntrySegment!) {
    createDataEntrySegment(dataEntrySegment: $segment) {
      id
      clientSegmentId
      amount
    }
  }
`;

export const UPDATE_DATA_ENTRY_SEGMENT = gql`
  mutation updateDataEntrySegment($id: ID!, $segment: UpdateDataEntrySegment!) {
    updateDataEntrySegment(id: $id, dataEntrySegment: $segment) {
      id
      clientSegmentId
      amount
    }
  }
`;

export const DELETE_DATA_ENTRY_SEGMENT = gql`
  mutation deleteDataEntrySegment($clientId: ID!, $dataEntrySegmentId: ID!) {
    deleteDataEntrySegment(clientId: $clientId, dataEntrySegmentId: $dataEntrySegmentId)
  }
`;

export const BULK_UPSERT_DATA_ENTRY_SEGMENTS = gql`
  mutation bulkUpsertDataEntrySegments($data: BulkUpsertDataEntrySegments!) {
    bulkUpsertDataEntrySegments(dataEntrySegments: $data)
  }
`;

export const BULK_DELETE_DATA_ENTRY_SEGMENTS = gql`
  mutation deleteMultipleDataEntrySegments(
    $clientId: ID!
    $journalEntryId: ID!
    $ledgerId: ID!
    $segmentId: ID!
  ) {
    deleteMultipleDataEntrySegments(
      clientId: $clientId
      journalEntryId: $journalEntryId
      ledgerId: $ledgerId
      segmentId: $segmentId
    )
  }
`;

export const GET_TRANSACTION_WITH_SEGMENTS = gql`
  query getTransactionWithSegments($transactionId: ID!) {
    journalEntry(id: $transactionId) {
      id
      dateOfTransaction
      vendorName
      categorization {
        categorizationUIClientComment
        selectedLedgerAccount {
          id
        }
      }
      dataEntries {
        id
        amountInCents
        entryType
        ledgerAccount {
          id
          name
        }
        segmentAllocations {
          clientCategoryId
          segments {
            id
            clientSegmentId
            amount
          }
        }
      }
    }
  }
`;
